import React from 'react';
import { Platform } from 'react-native';
import { HeaderTitle } from '@react-navigation/elements';
import { getTranslation } from '@/hooks/useTranslation';

export function getPromptDetailRouteNavigationOptions(prompt, slug) {
  const fallback = slug
    ? String(slug).replace(/-/g, ' ').replace(/\b\w/g, ch => ch.toUpperCase())
    : (getTranslation('nav.routes.prompts.detail') || 'Prompt');
  const title = prompt?.name || fallback;
  return {
    title,
    headerTitle: Platform.OS === 'web'
      ? props => <HeaderTitle {...props} role={undefined} aria-level={undefined} />
      : title,
    headerBackVisible: true,
  };
}

export default getPromptDetailRouteNavigationOptions;
